import { format } from 'date-fns'
import React from 'react'
import { emotions_heads } from '../../constants/Constants'
import i18n from '../../i18n'
import { datesAreOnSameDay, format_day } from '../../utils/util'

const Message = (props) => {
    const { message, user, messages, index, names, members, isGroupChat, visibleChats } = props

    const time = format(new Date(message.created_date), 'HH:mm')
    const messageSender = message.user_id
    const didUserSendMessage = messageSender === user.id
    const diff_next = message?.created_date - messages[index + 1]?.created_date
    const diff_previous = messages[index - 1]?.created_date - message?.created_date
    const minutes_next = Math.ceil(diff_next / (1000 * 60)) // seconds
    const minutes_previous = Math.ceil(diff_previous / (1000 * 60)) // seconds
    const nextMessageSameSender = index + 1 <= messages?.length && messages[index + 1]?.user_id === messageSender && minutes_next < 15
    const previousMessageSameSender = index - 1 >= 0 && messages[index - 1]?.user_id === messageSender && minutes_previous < 15
    const nextDate = new Date(messages[index + 1]?.created_date)
    const messageType = didUserSendMessage ? 'sent' : 'received'
    const date = new Date(message?.created_date)
    const showDate = !datesAreOnSameDay(date, nextDate)
    const name = names?.[messageSender] ?? ''
    const isFirstMessageInGroup = !nextMessageSameSender
    const isMiddleMessageInGroup = previousMessageSameSender && nextMessageSameSender
    const isLastMessageInGroup = !previousMessageSameSender
    const messageClass =
        isFirstMessageInGroup && isLastMessageInGroup ? 'only-message' : isMiddleMessageInGroup ? 'middle-message' : isLastMessageInGroup ? 'last-message' : 'first-message'
    const locale = i18n.language
    const isReply = !!message?.feedbackReply

    const parseMessage = (text) => {
        if (!text) return null

        const parts = text.split('\n').filter((p) => p.trim() !== '')

        if (parts.length <= 1) {
            return { topic: null, message: text }
        }

        return {
            topic: parts[0],
            message: parts.slice(1).join('\n'),
        }
    }
    const parsed = parseMessage(message.message_body)
    return (
        <div key={message.id} className={`single-message-group`}>
            {showDate && (
                <div className="messages-time" style={{ color: visibleChats ? 'var(--deep-ocean)' : '#fff' }}>
                    {format_day(message.created_date, false, locale)}
                </div>
            )}
            {!nextMessageSameSender && isGroupChat && !didUserSendMessage && (
                <p className="conversation-name" style={{ color: visibleChats ? 'var(--deep-ocean)' : '#fff' }}>
                    {name}
                </p>
            )}
            <div className={`conversation-message-wrapper ${messageType}-wrapper `}>
                <div className={`conversation-message ${messageType}-message ${messageClass}`}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <div className="conversation-message-text">
                            {parsed?.topic ? (
                                <>
                                    <div>
                                        <strong>{i18n.t('topic')}:</strong> {parsed.topic}
                                    </div>
                                    <div style={{ marginTop: 6 }}>
                                        <strong>{i18n.t('message')}:</strong> {parsed.message}
                                    </div>
                                </>
                            ) : (
                                <div style={{ whiteSpace: 'pre-line' }}>{message.message_body}</div>
                            )}
                        </div>
                        <div className={`${messageType}-message-time message-time`}>{time}</div>
                    </div>
                    {isReply && (
                        <div>
                            <div className="teacher-reply-emotion-row">
                                <span className="teacher-reply-emotion-row-label">Reply on: </span>
                                {React.cloneElement(emotions_heads[message?.feedbackReply?.emotion], {
                                    width: 20,
                                    height: 20,
                                })}
                            </div>
                            {!!message?.feedbackReply?.student_message && (
                                <div className="teacher-reply-text">
                                    "{message?.feedbackReply?.student_message}" - {user.first_name}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Message
